/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import i18n from './lang'
import { VueSignaturePad } from 'vue-signature-pad';
import NameDateSignatureVue from '#components/NameDateSignature/NameDateSignature.vue'
import SignaturePadVue from '#components/SignaturePad/SignaturePad.vue'
import DateInputVue from '#components/DateInput/DateInput.vue'
import ColoredRadioGroupVue from '#components/ColoredRadioGroup/ColoredRadioGroup.vue'

export function registerPlugins (app, formName = 'oneform') {
    app.use(vuetify);
    app.use(i18n(formName));
    app.component('SignaturePad', SignaturePadVue);
    app.component('VueSignaturePad', VueSignaturePad);
    app.component('NameDateSignature', NameDateSignatureVue);
    app.component('DateInput', DateInputVue);
    app.component('ColoredRadioGroup', ColoredRadioGroupVue);
}
